// extracted by mini-css-extract-plugin
export var active = "_2i-d";
export var blink = "_2i-e";
export var container = "_2i-5";
export var controls = "_2i-0";
export var controlsRight = "_2i-1";
export var fakeCursor = "_2i-c";
export var hidden = "_2i-b";
export var quillContainerSmall = "_2i-7";
export var quillEditor = "_2i-6";
export var quillEditorSmall = "_2i-8";
export var quillFormatButtons = "_2i-a";
export var quillToolbar = "_2i-9";
export var removePadding = "_2i-2";
export var state = "_2i-3";
export var stateTitle = "_2i-4";